function init() {
  const objectElement               = document.querySelector('.property');
  const objectID                    = (objectElement) ? objectElement.getAttribute('data-importid') : false;
  const objectName                  = document.querySelector('.propertyteaser__headline');
  const objectNameTitle 				= (objectName) ? objectName.textContent : false;
  const requestFormClassName        = '.propertyrequestinfo__formwrapper';
  const requestFormObjectIDField    = document.querySelector(requestFormClassName + ' .propertyrequestinfo__object-id input');
  const requestFormObjectNameField  = document.querySelector(requestFormClassName + ' .propertyrequestinfo__object-name input');
  const requestFormHeadlineCol1     = document.querySelector(requestFormClassName + ' .propertyrequestinfo__headline--col1');
  const requestFormHeadlineCol2     = document.querySelector(requestFormClassName + ' .propertyrequestinfo__headline--col2');
  const requestFormInfotext         = document.querySelector(requestFormClassName + ' .propertyrequestinfo__infotext');
  const requestFormCol1             = document.querySelector(requestFormClassName + ' .gform_body > ul > li:nth-child(1)');
  const requestFormCol2             = document.querySelector(requestFormClassName + ' .gform_body > ul > li:nth-child(2)');

  if (requestFormHeadlineCol1 && requestFormCol1) {
    requestFormCol1.prepend(requestFormHeadlineCol1);
  }

  if (requestFormInfotext && requestFormCol2) {
    requestFormCol2.prepend(requestFormInfotext);
  }

  if (requestFormHeadlineCol2 && requestFormCol2) {
    requestFormCol2.prepend(requestFormHeadlineCol2);
  }

  if (objectID && objectName && requestFormObjectIDField && requestFormObjectNameField) {
      requestFormObjectIDField.setAttribute('value', objectID);
      requestFormObjectNameField.setAttribute('value', objectNameTitle);
  }
}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Propertyrequestform.js